export default "/images/7c5748941d09f6b2724b55d3dd2185e6.png";